<template>
  <div id="app"
       v-if="true">
    <model-news class="model-news"></model-news>
    <header-view class="header-nav"></header-view>
    <div id="app-left"
         class="body-view">
      <left-side></left-side>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

    <guide-page v-if="showGuide" ref="guide"></guide-page>
    <network-error v-if="networkError"></network-error>
    <float-box></float-box>

    <alert-box class="alert-box"
               id="marketSentiment"
               title='热点情绪周期图'>
      <market-sent></market-sent>
    </alert-box>
    <alert-box class="alert-box zhangfu-box"
               id="blockZhangfu"
               title="板块表现">
      <block-zhangfu :showDetailChart="true"></block-zhangfu>
    </alert-box>

  </div>
</template>

<script>
import leftSide from '@/pages/common/leftSide.vue';
import rdhead from '@/components/header/rdhead.vue';
import guidePage from '@/pages/common/guidePage.vue';
import networkError from '@/pages/common/networkError.vue';
import floatBox from '@/components/floatBox/floatBox.vue';
import MarketSentiment from '@/components/charts/MarketSentiment.vue';

import blockZhangfu from '@/components/charts/blockZhangfu.vue';
import modelNews from '@/components/G2/modelNews.vue';
import { AlertBox } from '@/lib/alertbox/src';

export default {
  name: 'App',
  components: {
    'header-view': rdhead,
    'left-side': leftSide,
    'guide-page': guidePage,
    'network-error': networkError,
    'float-box': floatBox,
    'model-news': modelNews,
    'block-zhangfu': blockZhangfu,
    'alert-box': AlertBox,
    'market-sent': MarketSentiment
  },

  created() {
    eventBus.$on('closeGuide', this.handle);
    eventBus.$on('networkError', this.networkHandle);
  },
  mounted() {
    const self = this;
    self.resetAppHeight();
    if (window.navigator.onLine) {
      eventBus.$emit('networkError', false);
    } else {
      eventBus.$emit('networkError', true);
    }
    API.use({
      method: 'Passport.IsLevel2User',
      success(result) {
        if (!result) {
          self.isLevel2User = false;
        }
      }
    });
    $(window).resize(function() {
      //高度自适应
      self.resetAppHeight();
    });
    window.API.use({
      method: 'external.getUserPath', // 获取客户端下登陆用户的目录
      success(path) {
        window.API.use({
          method: 'fileReader.open',
          data: `${path  }\\l2hottrack\\guide.ini`,
          success(d) {
            if (!d) {
              if (window.clientType !== 2) {
                self.showGuide = true;
              }
              return;
            } // 没有读取到文件时，阻断继续
            window.API.use({
              method: 'fileReader.read',
              success(data) {
                if (Number(data) == 1 || window.clientType === 2) {
                  self.showGuide = false;
                } else {
                  self.showGuide = true;
                }
                window.API.use({ method: 'fileReader.close' });
              }
            });

          }
        });
      }
    });
    setTimeout(() => {
      API.use({
        method: 'external.registerEvent',
        data: 'onshow',
        persistent: true,
        callbackName: 'onshow',
        success(data) {
          // 1:显示 0:隐藏
          eventBus.$emit('onshow', data);
          if (data == 0) {
            // 隐藏窗口
            window.$onshow = false;
          } else if (data == 1) {
            // 显示窗口
            window.$onshow = true;
          }
        }
      });
    }, 3000);

    window.TA.log({ id: 'L2rdzz_5abb452c_825', _sid: 'L2rdzz_5abb452c_825' });
    window.TA.log({ id: 'pc_web_charge_l2hottrack', _sid: 'pc_web_charge_l2hottrack' });
    // $('#networkError').css('height',document.);
    document.onkeydown = function(e) {
      if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) {
        return false;
      }
    };
  },
  beforeDestroy() {
    eventBus.$off('closeGuide', this.handle);
    eventBus.$off('networkError', this.networkHandle);
  },
  updated() {
    if (this.$refs.guide) {
      this.$refs.guide.resize();
    }
  },
  data() {
    return {
      showGuide: false,
      networkError: false,
      isLevel2User: true
    };
  },
  methods: {
    handle() {
      this.showGuide = false;
    },
    networkHandle(val) {
      if (val == true) {
        this.networkError = true;
      } else {
        this.networkError = false;
      }
    },
    resetAppHeight() {
      if (document.body.clientHeight > 890) {
        $('#app').attr('style', `height:${  document.body.clientHeight - 13  }px`);
      } else {
        $('#app').attr('style', 'height:890px');
      }
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  min-width: 1366px;
  height: 100%;
  background: #000;
  font-family: 'Microsoft Yahei';
}

/* html,
body,
div {
  scrollbar-3dlight-color: #222;
  scrollbar-arrow-color: silver;
  scrollbar-base-color: #555;
  scrollbar-darkshadow-color: #222;
  scrollbar-face-color: #3e4404;
  scrollbar-shadow-color: #222;
  scrollbar-track-color: #111;
} */

html.white,
.white body {
  background: #f4f4f4;
}

.green {
  color: #1cbf7b;
}
.red {
  color: #db1919;
}
.hide {
  display: none;
}
.header-nav {
  position: fixed;
  width: 100%;
  clear: both;
  height: 36px;
  z-index: 22;
}

.body-view {
  margin-top: 36px;
}

::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 5px;
  height: 30px;
  transition: all 0.4s ease-out;
}

::-webkit-scrollbar-thumb {
  background: #303030;
}
.white ::-webkit-scrollbar-thumb {
  background: #777;
}
::-webkit-scrollbar-track-piece {
  background: transparent;
}

/* ::-webkit-scrollbar-thumb:vertical:hover,
::-webkit-scrollbar-thumb:horizontal:hover {
  background: #303030;
} */

::-webkit-scrollbar-corner {
  background: transparent;
}

::-webkit-resizer {
  background: transparent;
  opacity: 0;
}

#app {
  font-family: 'Microsoft Yahei', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1366px;
  overflow: hidden;
}

html,
body {
  min-width: 1250px;
  width: 100%;
}

.tooltips {
  color: #fff;
  text-align: left;
  border-radius: 5px 5px 5px 5px;
}
.hotanalysis-list #listContainer {
  height: 329px !important;
}
.hotanalysis-list #nameHead {
  height: 323px !important;
}
.pl-5 {
  padding-left: 5px;
}
.pl-20 {
  padding-left: 20px;
}

.wrap-title {
  color: #d9d9d9;
  font-size: 12px;
}
.pointer {
  cursor: pointer;
}
.zhangfu-box {
  top: 100px;
}
#marketSentiment {
  top: 56% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue